/**************************************************
 * Nombre:       Nosotros_Logos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import agave from "../../../Recursos/Temporales/agave.svg";
import {contexApp} from "../../../App";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import {useNavigate} from "react-router";


const Nosotros_Logos = () => {
    const cData = useContext(contexApp)
    const {sCell} = useResponsive()
    const navigate = useNavigate();
    const [marcas, setMarcas] = useState([]);

    useEffect(() => {

        setMarcas(cData.marcas)

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                    <Splide
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage:sCell ? 3 : 8,
                            arrows: false,
                            pagination: false,
                            width: '100%',
                            drag: false,
                            interval: 8000,
                            noDrag: true,
                            type: 'loop',
                            gap: sCell ? 10 : 40


                        }}
                    >

                        {marcas.map((item, index) => {
                            return (
                                <SplideSlide key={`qse${index}`}>
                                    <Grid
                                        onClick={() => navigate('/Catalogo/Palabra/' + item.nombre)}
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'center'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        sx={{
                                            height: 120,
                                            cursor: 'pointer',
                                            ':hover': {
                                                scale: 1.1
                                            }
                                        }}

                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <img src={item.img} width={'100%'}/>
                                        </Grid>

                                    </Grid>

                                </SplideSlide>
                            )
                        })}


                    </Splide>


                </Grid>

            </Grid>

        </Grid>
    )

}
export default Nosotros_Logos